import { Box, Divider } from "@mui/material";
import kebabCase from "lodash/kebabCase";
import { Fragment } from "react/jsx-runtime";
import { Typography } from "@platform/design-system";

import { FileCollectionMap } from "../../types";
import DropzoneCustom, {
  DropzoneCustomProps,
} from "../DropzoneCustom/dropzone-custom";

type OmitDropzone = Omit<DropzoneCustomProps, "files">;

type Section = {
  title: string;
  pathToData: string;
  dropzoneProps: OmitDropzone;
  emptyMessage?: string;
};

const DocumentSections = ({
  sections,
  data,
}: {
  sections: Section[];
  data: FileCollectionMap;
}): React.JSX.Element => (
  <Box display="flex" flexDirection="row">
    {sections.map((section, index) => (
      <Fragment key={section.title}>
        <DocumentSection section={section} data={data} />
        {index !== sections.length - 1 ? (
          <Divider orientation="vertical" flexItem sx={{ mx: 3 }} />
        ) : null}
      </Fragment>
    ))}
  </Box>
);

function DocumentSection({
  section,
  data,
}: {
  section: Section;
  data: FileCollectionMap;
}): React.JSX.Element {
  const files = data?.[section.pathToData] ?? [];
  return (
    <Box
      data-testid={`ds-card-documents-section-${kebabCase(section.title)}`}
      key={section.title}
      sx={{ flex: 1 }}
    >
      <Typography variant="header-small" component="h6" mb={3}>
        <strong>{section.title}</strong>
      </Typography>
      {files.length === 0 && section.emptyMessage ? (
        <Typography color="textSecondary" mt={1}>
          {" "}
          {section.emptyMessage}
        </Typography>
      ) : (
        <Box>
          <DropzoneCustom
            data-testid="ds-card-documents-dropzone"
            files={files}
            {...section.dropzoneProps}
          />
        </Box>
      )}
    </Box>
  );
}

export { DocumentSection, DocumentSections };
export type { Section };
